import React from "react";
import Footer from "../components/Footer";
import Routes from "../routes/Routes";

const App = () => {
  return (
    <div>
      <Routes />
      <Footer />
    </div>
  );
};

export default App;
